export default "__VITE_ASSET__B8qAnSF7__"